import React, { useEffect, useState } from "react";
import {
  Breadcrumbs,
  Button,
  Modal,
  Select,
  Textarea,
  Textfield,
} from "../../../components/core";
import { ContentContainer } from "../../../components/layout";
import { useApolloClient, useMutation, useQuery } from "@apollo/client";
import { CREATE_BRANCH } from "../../../constants/graphql/branch-queries";
import { PARTNERS } from "../../../constants/graphql/partner-agent-queries";
import {
  clearBranchProfile,
  getPartnerList,
  handleOnChangeReducer,
} from "../../../features/branches/add-branch-slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PatternFormat } from "react-number-format";
import useSidebarStore from "../../../zustand/stores/sidebar-store";
const breadcrumbItems = [
  {
    label: "Branches",
    path: `/branches/`,
  },
  { label: "Add Branch", path: "#" },
];

function areRequiredFieldsEmptyOrNull(obj) {
  const requiredFields = [
    "operatorId",
    "partnerId",
    "partnerBranch",
    // "address",
    "contactPerson",
    "contactPerson2",
    // "zipCode",
    "mobile",
    "mobile2",
    "email",
    "email2",
    // "branchStatus",
  ];

  for (const key of requiredFields) {
    if (obj[key] === null || obj[key] === "") {
      return true; // At least one required field is empty or null
    }
  }
  return false; // All required fields are filled
}
export default function AddBranch() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const [editingFlag, setEditingFlag] = useState(false);
  const [successValidation, setSuccessValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    submessage: "Confirm this change?",
    open: false,
  });
  const [changesMade, setChangesMade] = useState(false);
  // utils
  const dispatch = useDispatch();
  const client = useApolloClient();
  const navigate = useNavigate();
  //gql
  const [createBranch] = useMutation(CREATE_BRANCH);
  const partners = useQuery(PARTNERS, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  // selectors
  const partnerList = useSelector((state) => state.addBranch.partnerList);
  const branchProfile = useSelector((state) => state.addBranch.branchProfile);

  const [validationErrors, setvalidationErrors] = React.useState({
    partnerId: false,
    partnerBranch: false,
    // "address": false,
    contactPerson: false,
    contactPerson2: false,
    // "zipCode": false,
    mobile: false,
    mobile2: false,
    email: false,
    email2: false,
  });
  const [landlineAreaCode, setLandlineAreaCode] = useState("");
  const [landline1, setlandline1] = useState("");
  const [landlineAreaCode2, setLandlineAreaCode2] = useState("");
  const [landline2, setLandline2] = useState("");

  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });

  const [openSaveModal, setOpenSaveModal] = React.useState(false);
  const [openCancelModal, setOpenCancelModal] = React.useState(false);

  const handleCancelChanges = () => {
    setOpenCancelModal(false);
    window.history.go(-1);
  };
  const handleOnChange = (event) => {
    const { name, value, checked } = event.target;
    setChangesMade(true);
    dispatch(
      handleOnChangeReducer({ name: name, value: value, checked: checked })
    );
  };
  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  const handleSaveChange = () => {
    const updatedData = {
      ...branchProfile,
      // landline: landlineAreaCode + "*" + landline1,
      // landline2: landlineAreaCode2 + "*" + landline2,
      mobile: "63" + branchProfile.mobile,
      mobile2: "63" + branchProfile.mobile2,
      zipCode: 1,
    };
    console.log(updatedData);
    if (areRequiredFieldsEmptyOrNull(updatedData)) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid entry",
        message: "Please fill all required fields.",
        open: true,
      });
    } else {
      client.clearStore();
      createBranch({ variables: { branches: [updatedData] } })
        .then((data) => {
          if (data.data) {
            const partnerBranchId =
              data.data.createBranch.partnerBranch.partnerBranchId;
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
              title: "Success",
              message: "Successfully added this branch profile.",
              open: true,
            });
            client.clearStore();
          }
        })
        .catch((e) => {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: "Invalid operation",
            message:
              "Please check your entry if there is duplication of Branch or check your internet connection.",
            open: true,
          });
        });
    }
    setOpenSaveModal(false);
  };
  React.useEffect(() => {
    if (partners.data) {
      let tempVar = [];
      partners.data.partners.forEach((element) => {
        tempVar.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      dispatch(getPartnerList(tempVar));
    }
  }, [partners.data]);
  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setOpenCancelModal(true);
        // setValidation({
        // 	icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        // 	title: `${Strings.popup_confirm_cancel_title}?`,
        // 	message: Strings.popup_confirm_cancel_massage,
        // 	open: true,
        // 	actions: (
        // 		<div className="flex justify-between gap-3">
        // 			<Button
        // 				onClick={() => {
        // 					setValidation({ open: false });
        // 					// window.location.reload();
        // 					setPendingNavigation(null);
        // 					setActiveSubItem(activeSubItem);
        // 				}}
        // 				value={"No"}
        // 				className={"p-2 w-full"}
        // 			/>
        // 			<Button
        // 				onClick={() => {
        // 					navigate(pendingNavigation);
        // 					setPendingNavigation(null);
        // 				}}
        // 				value={"Yes"}
        // 				className={"p-2 w-full"}
        // 			/>
        // 		</div>
        // 	),
        // });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  // return (
  // 	<div>
  // 		<Breadcrumbs items={breadcrumbItems} />
  // 		<ContentContainer containerTitle={`ADD A BRANCH`}>
  // 			<>
  // 				<div className="flex">
  // 					<div className="left w-1/2 grid grid-cols-2 gap-x-2 gap-y-6 pr-2">
  // 						{/* <div></div> */}
  // 						{/* <Checkbox
  //             label="Head office"
  //             onChange={handleOnChange}
  //             name="branchLevel"
  //           /> */}
  // 						<p className="my-auto">Partner:</p>
  // 						<Select
  // 							items={partnerList}
  // 							name="partnerId"
  // 							value={branchProfile.partnerId}
  // 							onChange={handleOnChange}
  // 							defaultOption={{ value: "-2", name: "-- Select a partner --" }}
  // 						/>
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Branch Name:
  // 						</p>
  // 						<Textfield
  // 							type="text"
  // 							name="partnerBranch"
  // 							maxLength={32}
  // 							value={branchProfile.partnerBranch}
  // 							onChange={handleOnChange}
  // 						/>
  // 						{/* Leave the location for now, it's to be fixed */}
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Country:
  // 						</p>
  // 						<Select disabled={true} />
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Region:
  // 						</p>
  // 						<Select disabled={true} />
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Province:
  // 						</p>
  // 						<Select disabled={true} />
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>City/District:
  // 						</p>
  // 						<Select disabled={true} />
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Barangay:
  // 						</p>
  // 						<Select disabled={true} />
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Address:
  // 						</p>
  // 						<Textarea
  // 							name="address"
  // 							maxLength={96}
  // 							value={branchProfile.address}
  // 							onChange={handleOnChange}
  // 						/>
  // 						{/* ------------------------------------------- */}
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>ZIP Code:
  // 						</p>
  // 						<Textfield
  // 							type={"text"}
  // 							maxLength={4}
  // 							name="zipCode"
  // 							value={branchProfile.zipCode}
  // 							onChange={handleOnChange}
  // 						/>
  // 					</div>
  // 					{/* <div className="right w-1/2 grid grid-cols-2 gap-2 pl-2 h-1/2">
  //           <p className="my-auto">Status:</p>
  //           <p className="my-auto">
  //             {branchProfile.branchStatus > -1
  //               ? branchProfile.branchStatus === "0" ||
  //                 branchProfile.branchStatus === 0
  //                 ? "Suspended"
  //                 : "Active"
  //               : "Unknown"}
  //           </p>
  //           <p className="my-auto">Change Current Status to:</p>
  //           <Select
  //             name="branchStatus"
  //             value={branchProfile.branchStatus.toString()}
  //             items={[
  //               { value: 0, name: "Suspended" },
  //               { value: 1, name: "Active" },
  //             ]}
  //             defaultOption={{ value: -1, name: "-- Select Status --" }}
  //             onChange={handleOnChange}
  //           />
  //           <p className="my-auto">Reason for Status Change:</p>
  //           <Textarea
  //             maxLength={1000}
  //             name="statusComments"
  //             value={branchProfile.statusComments}
  //             onChange={handleOnChange}
  //           />
  //         </div> */}
  // 				</div>
  // 				{/* Contacts Person */}
  // 				<div className="bg-stone-100 w-full mt-4 p-2 flex">
  // 					<div className="grid grid-cols-2 gap-x-2 gap-y-4 pr-2 border-r-2 border-stone-300">
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Contact Person 1:
  // 						</p>
  // 						<Textfield
  // 							name="contactPerson"
  // 							maxLength={32}
  // 							value={branchProfile.contactPerson}
  // 							onChange={handleOnChange}
  // 						/>
  // 						<p className="my-auto">Position:</p>
  // 						<Textfield
  // 							name="contactPosition"
  // 							maxLength={32}
  // 							value={branchProfile.contactPosition}
  // 							onChange={handleOnChange}
  // 						/>
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Mobile Number:
  // 						</p>
  // 						<Textfield
  // 							name="mobile"
  // 							maxLength={12}
  // 							value={branchProfile.mobile}
  // 							onChange={handleOnChange}
  // 						/>
  // 						<p className="my-auto">Landline:</p>
  // 						<PatternFormat
  // 							valueIsNumericString
  // 							format="###-#########"
  // 							mask=""
  // 							name="landline"
  // 							placeholder="XXX-XXXXXXXXX"
  // 							value={branchProfile.landline}
  // 							onChange={handleOnChange}
  // 							customInput={Textfield}
  // 						/>
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Email Address:
  // 						</p>
  // 						<Textfield
  // 							name="email"
  // 							maxLength={64}
  // 							value={branchProfile.email}
  // 							onChange={handleOnChange}
  // 						/>
  // 					</div>
  // 					<div className="grid grid-cols-2 gap-x-2 gap-y-4 pl-2">
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Contact Person 2:
  // 						</p>
  // 						<Textfield
  // 							name="contactPerson2"
  // 							maxLength={32}
  // 							value={branchProfile.contactPerson2}
  // 							onChange={handleOnChange}
  // 						/>
  // 						<p className="my-auto">Position:</p>
  // 						<Textfield
  // 							name="contactPosition2"
  // 							maxLength={32}
  // 							value={branchProfile.contactPosition2}
  // 							onChange={handleOnChange}
  // 						/>
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Mobile Number:
  // 						</p>
  // 						<Textfield
  // 							name="mobile2"
  // 							maxLength={12}
  // 							value={branchProfile.mobile2}
  // 							onChange={handleOnChange}
  // 						/>
  // 						<p className="my-auto">Landline:</p>
  // 						<PatternFormat
  // 							valueIsNumericString
  // 							format="###-#########"
  // 							mask=""
  // 							name="landline2"
  // 							placeholder="XXX-XXXXXXXXX"
  // 							value={branchProfile.landline2}
  // 							onChange={handleOnChange}
  // 							customInput={Textfield}
  // 						/>
  // 						<p className="my-auto flex">
  // 							<p className="text-red-500">*</p>Email Address:
  // 						</p>
  // 						<Textfield
  // 							name="email2"
  // 							maxLength={64}
  // 							value={branchProfile.email2}
  // 							onChange={handleOnChange}
  // 						/>
  // 					</div>
  // 				</div>
  // 				{/* ID's and other checkboxes */}
  // 				<div className="grid grid-cols-2 w-2/3 mt-2 gap-y-4">
  // 					<p className="my-auto">Remarks:</p>
  // 					<Textarea
  // 						name="remarks"
  // 						maxLength={1000}
  // 						value={branchProfile.remarks}
  // 						onChange={handleOnChange}
  // 					/>
  // 				</div>

  // 				<div className="grid grid-cols-2 gap-2 w-1/3">
  // 					<Button
  // 						value={"Cancel"}
  // 						className={"p-2"}
  // 						onClick={() => setOpenCancelModal(true)}
  // 					/>
  // 					<Button
  // 						value={"Save Changes"}
  // 						className={"p-2"}
  // 						onClick={() => setOpenSaveModal(true)}
  // 					/>
  // 				</div>
  // 				<Modal
  // 					icon={`${process.env.PUBLIC_URL}/assets/images/check.png`}
  // 					title="Save Changes"
  // 					message="Are you sure you want to save all changes?"
  // 					open={openSaveModal}
  // 					actions={
  // 						<div className="grid grid-cols-2 gap-2">
  // 							<Button
  // 								onClick={() => setOpenSaveModal(false)}
  // 								value={"No"}
  // 								className={"p-2"}
  // 							/>
  // 							<Button
  // 								onClick={() => handleSaveChanges()}
  // 								value={"Yes"}
  // 								className={"p-2"}
  // 							/>
  // 						</div>
  // 					}
  // 				/>
  // 				<Modal
  // 					icon={`${process.env.PUBLIC_URL}/assets/images/error.png`}
  // 					title="Cancel Changes"
  // 					message="Are you sure you want to cancel all changes?"
  // 					open={openCancelModal}
  // 					actions={
  // 						<div className="grid grid-cols-2 gap-2">
  // 							<Button
  // 								onClick={() => setOpenCancelModal(false)}
  // 								value={"No"}
  // 								className={"p-2"}
  // 							/>
  // 							<Button
  // 								onClick={() => handleCancelChanges()}
  // 								value={"Yes"}
  // 								className={"p-2"}
  // 							/>
  // 						</div>
  // 					}
  // 				/>
  // 				<Modal
  // 					icon={validation.icon}
  // 					title={validation.title}
  // 					message={validation.message}
  // 					open={validation.open}
  // 					actions={
  // 						<div className="grid grid-cols-1 gap-2">
  // 							<Button
  // 								onClick={() => {
  // 									validation.title == "Success" ? navigate(`/branches/`) :
  // 										setValidation({
  // 											icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
  // 											title: "Invalid data",
  // 											message: "",
  // 											open: false,
  // 										});
  // 								}}
  // 								value={"OK"}
  // 								className={"p-2"}
  // 							/>
  // 						</div>
  // 					}
  // 				/>
  // 			</>
  // 		</ContentContainer>
  // 	</div>
  // );
  return (
    <div>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer containerTitle={`Add Branch`}>
        <>
          <div className="w-full grid grid-cols-5 gap-x-2 gap-y-2 pr-2 mb-[20px]">
            <p className="my-auto mr-2">Partner:</p>
            <div className="col-span-2">
              <Select
                items={partnerList}
                name="partnerId"
                value={branchProfile.partnerId}
                onChange={handleOnChange}
                defaultOption={{ value: "-2", name: "-- Select a partner --" }}
              />
            </div>
            <p className="text-red-800 my-auto italic w-full">
              {validationErrors.partnerId == true
                ? "This field is required"
                : " "}
            </p>
            <div></div>
            <div>
              <i className="text-red-500">*</i>Branch Name:
            </div>
            <div className="col-span-3">
              <Textfield
                classNameParent={" flex flex-row"}
                className={`${
                  validationErrors.partnerBranch ? "border-red-500" : ""
                } w-full`}
                type="text"
                name="partnerBranch"
                maxLength={32}
                value={branchProfile.partnerBranch}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.partnerBranch == true
                      ? "This field is required"
                      : " "}
                  </p>
                }
              />
            </div>
            {/*
						<div className="col-span-1"></div>
						<div className="my-auto flex">
							<p className="text-red-500">*</p>Country:
						</div>
						<Select disabled={true} />
						<div className="col-span-3"></div>

						<div className="my-auto flex">
							<p className="text-red-500">*</p>Region:
						</div>
						<Select disabled={true} />
						<div className="col-span-3"></div>


						<div className="my-auto flex">
							<p className="text-red-500">*</p>Province:
						</div>
						<Select disabled={true} />
						<div className="col-span-3"></div>


						<div className="my-auto flex">
							<p className="text-red-500">*</p>City/District:
						</div>
						<Select disabled={true} />
						<div className="col-span-3"></div>


						<div className="my-auto flex">
							<p className="text-red-500">*</p>Barangay:
						</div>
						<Select disabled={true} />
						<div className="col-span-3"></div>


						<div className="my-auto flex">
							<p className="text-red-500">*</p>Address:
						</div>

						<div className="col-span-2 mt-[20px]">
							<Textarea
								name="address"
								maxLength={96}
								value={branchProfile.address}
								onChange={handleOnChange}
								disabled={
									accessPermission.branches === 1 ||
									accessPermission.branches === "1"
								}
								classNameInside={`${validationErrors.address ? " border border-red-500" : ""}`}
								error={
									<p className="text-red-800 my-auto italic">
										{validationErrors.address == true
											? "This field is required"
											: ""}
									</p>
								}
							/>
						</div>
						<div className="col-span-2"></div>

						<p className="my-auto flex">
							<p className="text-red-500">*</p>ZIP Code:
						</p>
						<Textfield
							type={"text"}
							maxLength={4}
							name="zipCode"
							value={branchProfile.zipCode}
							onChange={(e) => {
								if (/^\d*$/.test(e.target.value)
								) { handleOnChange(e) }
							}}
							disabled={
								accessPermission.branches === 1 ||
								accessPermission.branches === "1"
							}
							className={`${validationErrors.zipCode ? "border-red-500" : ""} w-full`}
							error={
								<p className="text-red-800 my-auto italic w-full">
									{validationErrors.zipCode
										? "This field is required (4 digits)"
										: ""}
								</p>
							}
						/>
						*/}
          </div>

          <hr className="col-span-3 my-2"></hr>
          <p className="font-bold col-span-3 text-lg">CONTACT PEOPLE</p>
          {/* Contacts Person */}
          <div className="col-span-5 grid grid-cols-5 gap-2 my-2 bg-secondary-buttonGray py-4 px-2">
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Contact Person 1:
            </p>
            <div className="col-span-2">
              <Textfield
                className={`${
                  validationErrors.contactPerson ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.contactPerson
                      ? "This field is required"
                      : ""}
                  </p>
                }
                name="contactPerson"
                maxLength={32}
                value={branchProfile.contactPerson}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>

            <p className="my-auto">Position:</p>
            <div className="col-span-2">
              <Textfield
                className="w-1/2"
                name="contactPosition"
                value={branchProfile.contactPosition}
                maxLength={32}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Mobile Number:
            </p>
            <div className="col-span-2 flex flex-row items-center justify-start">
              <p className="mr-[5px]">+63</p>
              <Textfield
                className={`${
                  validationErrors.mobile ? "border-red-500" : ""
                } w-full min-w-[220px]`}
                error={
                  <p className="text-red-800 my-auto italic w-full ">
                    {validationErrors.mobile
                      ? "This field is required (9XXXXXXXXX)"
                      : ""}
                  </p>
                }
                name="mobile"
                maxLength={10}
                value={branchProfile.mobile}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>
            <div className="flex flex-row justify-between w-full items-center">
              <p className="ml-2">Landline:</p>
              <div className="col-span-2">
                <Textfield
                  placeholder={"(02)"}
                  className={`w-[50px] text-center`}
                  autocomplete="off"
                  name={"landline"}
                  onChange={(e) => {
                    setLandlineAreaCode(e.target.value);
                    setEditingFlag(true);
                  }}
                  value={landlineAreaCode}
                  maxLength={3}
                />
              </div>
            </div>
            <PatternFormat
              valueIsNumericString
              format="########"
              mask=""
              name="landline"
              placeholder="XXXXXXXXX"
              onChange={(e) => {
                setlandline1(e.target.value);
                setEditingFlag(true);
              }}
              value={landline1}
              customInput={Textfield}
              disabled={
                accessPermission.branches === 1 ||
                accessPermission.branches === "1"
              }
            />
            <div className="col-span-3"></div>
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Email Address:
            </p>
            <div className="col-span-2">
              <Textfield
                className={`${
                  validationErrors.email ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.email
                      ? "This field is required (e.g. account@mbox.com)"
                      : ""}
                  </p>
                }
                name="email"
                maxLength={64}
                value={branchProfile.email}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
          </div>
          <div className="col-span-5 grid grid-cols-5 gap-2 my-2 bg-secondary-buttonGray py-4 px-2">
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Contact Person 2:
            </p>
            <div className="col-span-2">
              <Textfield
                className={`${
                  validationErrors.contactPerson2 ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.contactPerson2
                      ? "This field is required"
                      : ""}
                  </p>
                }
                name="contactPerson2"
                maxLength={32}
                value={branchProfile.contactPerson2}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>
            <p className="my-auto">Position:</p>
            <div className="col-span-2">
              <Textfield
                className="w-1/2"
                name="contactPosition2"
                value={branchProfile.contactPosition2}
                onChange={handleOnChange}
                maxLength={32}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
            <div className="col-span-2"></div>
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Mobile Number:
            </p>
            <div className="col-span-2 flex flex-row items-center justify-start">
              <p className="mr-[5px]">+63</p>
              <Textfield
                className={`${
                  validationErrors.mobile2 ? "border-red-500" : ""
                } w-full min-w-[220px]`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.mobile2
                      ? "This field is required (9XXXXXXXXX)"
                      : ""}
                  </p>
                }
                name="mobile2"
                maxLength={10}
                value={branchProfile.mobile2}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>{" "}
            <div className="col-span-2"></div>
            <div className="flex flex-row justify-between w-full items-center">
              <p className="ml-2">Landline:</p>
              <Textfield
                placeholder={"(02)"}
                className={`w-[50px] text-center`}
                autocomplete="off"
                name={"landline2"}
                onChange={(e) => {
                  setLandlineAreaCode2(e.target.value);
                  setEditingFlag(true);
                }}
                value={landlineAreaCode2}
                maxLength={3}
              />
            </div>
            <PatternFormat
              valueIsNumericString
              format="########"
              mask=""
              name="landline2"
              placeholder="XXXXXXXXX"
              onChange={(e) => {
                setLandline2(e.target.value);
                setEditingFlag(true);
              }}
              value={landline2}
              customInput={Textfield}
              disabled={
                accessPermission.branches === 1 ||
                accessPermission.branches === "1"
              }
            />
            <div className="col-span-3"></div>
            <p className="my-auto flex">
              <p className="text-red-500">*</p>Email Address:
            </p>
            <div className="col-span-2">
              <Textfield
                className={`${
                  validationErrors.email2 ? "border-red-500" : ""
                } w-full`}
                error={
                  <p className="text-red-800 my-auto italic w-full">
                    {validationErrors.email2
                      ? "This field is required (e.g. account@mbox.com)"
                      : ""}
                  </p>
                }
                name="email2"
                maxLength={64}
                value={branchProfile.email2}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
          </div>
          {/* ID's and other checkboxes */}
          <div className="grid grid-cols-5 mt-2 gap-y-4">
            <p className="my-auto">Remarks:</p>
            <div className="col-span-2">
              <Textarea
                name="remarks"
                maxLength={1000}
                value={branchProfile.remarks}
                onChange={handleOnChange}
                disabled={
                  accessPermission.branches === 1 ||
                  accessPermission.branches === "1"
                }
              />
            </div>
          </div>
          <div className={`mt-[30px] grid grid-cols-2 gap-2 w-1/3`}>
            <Button
              value={"Cancel"}
              disabled={
                accessPermission.branches === 1 ||
                accessPermission.branches === "1"
              }
              className={"p-2"}
              onClick={() => setOpenCancelModal(true)}
            />
            <Button
              value={"ADD BRANCH"}
              disabled={
                accessPermission.branches === 1 ||
                accessPermission.branches === "1"
              }
              className={"p-2"}
              onClick={() => {
                setvalidationErrors({
                  partnerId: false,
                  partnerBranch: false,
                  address: false,
                  // "zipCode": false,
                  contactPerson: false,
                  contactPerson2: false,
                  mobile: false,
                  mobile2: false,
                  email: false,
                  email2: false,
                });

                var thereIsError = false;
                ///Validate here
                console.log(branchProfile);
                if (branchProfile.partnerId == "") {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    partnerId: true,
                  }));
                  thereIsError = true;
                  console.log("1");
                }
                if (branchProfile.partnerBranch.toString() == "") {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    partnerBranch: true,
                  }));
                  thereIsError = true;
                  console.log("2");
                }
                // if (branchProfile.address.toString() == "") {
                // 	setvalidationErrors(prevErrors => ({ ...prevErrors, address: true }))
                // 	thereIsError = true; console.log("3");
                // }
                // if (branchProfile.zipCode.toString() == "") {
                // 	setvalidationErrors(prevErrors => ({ ...prevErrors, zipCode: true }))
                // 	thereIsError = true; console.log("4");
                // }
                if (branchProfile.contactPerson.toString() == "") {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    contactPerson: true,
                  }));
                  thereIsError = true;
                  console.log("5");
                }
                if (!/^9\d{9}$/.test(branchProfile.mobile.toString())) {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    mobile: true,
                  }));
                  thereIsError = true;
                  console.log("6");
                }
                if (
                  !/^(?:\d{3}-\d{4}|\d{2}-\d{4}|(?:\+?63|\+?09)\d{9})$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
                    branchProfile.email.toString()
                  )
                ) {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    email: true,
                  }));
                  thereIsError = true;
                }
                if (branchProfile.contactPerson2.toString() == "") {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    contactPerson2: true,
                  }));
                  thereIsError = true;
                }
                if (!/^9\d{9}$/.test(branchProfile.mobile2.toString())) {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    mobile2: true,
                  }));
                  thereIsError = true;
                }
                if (
                  !/^(?:\d{3}-\d{4}|\d{2}-\d{4}|(?:\+?63|\+?09)\d{9})$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
                    branchProfile.email2.toString()
                  )
                ) {
                  setvalidationErrors((prevErrors) => ({
                    ...prevErrors,
                    email2: true,
                  }));
                  thereIsError = true;
                }
                if (thereIsError) {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  return;
                }
                setOpenSaveModal(true);
              }}
            />
          </div>

          <Modal
            icon={`${process.env.PUBLIC_URL}/assets/images/check.png`}
            title="Save Changes"
            message="Are you sure you want to save all changes?"
            open={openSaveModal}
            actions={
              <div className="grid grid-cols-2 gap-2">
                <Button
                  onClick={() => setOpenSaveModal(false)}
                  value={"No"}
                  className={"p-2"}
                />
                <Button
                  onClick={handleSaveChange}
                  value={"Yes"}
                  className={"p-2"}
                />
              </div>
            }
          />
          <Modal
            icon={`${process.env.PUBLIC_URL}/assets/images/error.png`}
            title="Cancel Changes"
            message="Are you sure you want to cancel all changes?"
            open={openCancelModal}
            actions={
              <div className="grid grid-cols-2 gap-2">
                <Button
                  onClick={() => {
                    setOpenCancelModal(false);
                    setActiveSubItem(activeSubItem);
                    setPendingNavigation(null);
                  }}
                  value={"No"}
                  className={"p-2"}
                />
                <Button
                  onClick={() => {
                    if (pendingNavigation) {
                      navigate(pendingNavigation);
                      setPendingNavigation(null);
                      setChangesMade(false);
                      // handleCancelChanges();
                      dispatch(clearBranchProfile());
                    } else {
                      dispatch(clearBranchProfile());

                      handleCancelChanges();
                    }
                  }}
                  value={"Yes"}
                  className={"p-2"}
                />
              </div>
            }
          />
          <Modal
            icon={successValidation.icon}
            title={successValidation.title}
            message={successValidation.message}
            submessage={successValidation.submessage}
            open={successValidation.open}
            className="w-1/3"
            actions={
              <div className="grid grid-cols-1 gap-2 mt-2">
                <Button
                  onClick={() => {
                    setSuccessValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));
                  }}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            }
          />
          {/* Modal for head office validations */}
          <Modal
            icon={validation.icon}
            title={validation.title}
            message={validation.message}
            submessage={validation.submessage}
            open={validation.open}
            className="w-1/3"
            actions={
              <div
                className={
                  validation.title == "Success" ||
                  validation.title == "Invalid operation"
                    ? "grid grid-cols-1 gap-2 mt-2"
                    : "grid grid-cols-2 gap-2 mt-2"
                }
              >
                {validation.title == "Success" ||
                validation.title == "Invalid operation" ? (
                  <>
                    <Button
                      onClick={() => {
                        validation.title == "Success"
                          ? (window.location.href = "/operator/admin/branches/")
                          : setValidation((prev) => ({
                              ...prev,
                              open: false,
                            }));
                      }}
                      value={"OK"}
                      className={"p-2"}
                    />
                  </>
                ) : (
                  <>
                    <Button
                      onClick={() => {
                        setValidation((prev) => ({
                          ...prev,
                          open: false,
                        }));
                        dispatch(
                          handleOnChangeReducer({
                            name: "branchLevel",
                            checked: false,
                          })
                        );
                      }}
                      value={"No"}
                      className={"p-2"}
                    />
                    {validation.title == "Success" ? (
                      <Button
                        onClick={() => {
                          setValidation({
                            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                            title: "Invalid data",
                            message: "",
                            open: false,
                          });
                          dispatch(
                            handleOnChangeReducer({
                              name: "branchLevel",
                              checked: true,
                            })
                          );
                        }}
                        value={"Yes"}
                        className={"p-2"}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </div>
            }
          />
        </>
      </ContentContainer>
    </div>
  );
}
